var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sliderBarDialogShell',{staticClass:"add-pushRule-dialog",attrs:{"click-not-close":true,"dialog-show":_vm.dialogShow,"dialog-title":_vm.title},on:{"close":_vm.beforeClose,"submit":_vm.confirm}},[_c('push-rule-form',{ref:"outform",on:{"submit":_vm.submit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }